import React from 'react';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import { get, debounce } from 'lodash';
import { toast } from 'react-toastify';
import { Form } from 'informed';
import FormContainer from '../../containers/Form';
import { BaseForm } from '../../base';
import { InputSelect } from '../../components/inputs';
import { API_HOST } from '../../consts';
import Loading from '../../components/Loading';

let bibliografia = [];
const mapBibliografiaComplementar = (x) => ({
  value: x.id,
  label: bibliografia
    .concat(
      x.disciplina.descricao,
      x.autor,
      x.obra,
      x.edicao,
      x.tema,
      x.sub_tema
    )
    .toString()
});

class ReferenciaBibliograficaComplementar extends BaseForm {
  constructor(props) {
    super(props);
    this.multiFields = ['bibliografia_complementar'];
    this.onValueChange = this.onValueChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  state = {
    bibliografia_complementar: [],
    submitting: false,
    save: this.OK,
    fetchingData: true
  };

  componentDidMount() {
    this.fetchData();
    this.fetchBibliografiaComplementar();
  }

  fetchData() {
    if (this.id !== 'new') {
      axios.get(`${API_HOST}/itens/item/${this.id}/form`).then((response) => {
        const { data } = response;
        this.setFields({ ...data });
        this.setState({ fetchingData: false });
      });
    } else {
      this.setState({ fetchingData: false });
    }
  }

  fetchBibliografiaComplementar() {
    axios
      .get(`${API_HOST}/itens/bibliografia-complementar`)
      .then((response) => {
        this.setState({
          bibliografia_complementar: response.data.map(
            mapBibliografiaComplementar
          )
        });
      });
  }

  handleSubmit = (values) => {
    this.setState({ submitting: true });

    Object.keys(values).forEach((x) => {
      if (values[x] === '') {
        values[x] = null;
      }
    });

    if (this.id !== 'new') {
      axios
        .patch(`${API_HOST}/itens/item/${this.id}`, values)
        .then((response) => {
          const { history } = this.props;
          this.id = response.data.id;
          history.push(`/itens/${this.id}/conteudo`);
        })
        .catch(this.onValidateError);
    }
  };

  onValueChange = debounce((values) => {
    this.setState({ save: this.SALVANDO });
    axios
      .patch(`${API_HOST}/itens/item/${this.id}`, values)
      .then(() => {
        this.setState({ save: this.SALVO });
      })
      .catch(() => {
        this.setState({ save: this.ERRO });
      });
  }, 1000);

  onSubmit(url) {
    axios
      .get(
        `${API_HOST}/itens/item/${this.id}/validate?form=bibliografia_complementar`
      )
      .then(() => {
        const { history } = this.props;
        history.push(`/itens/${this.id}/${url}`);
      })
      .catch((error) => {
        this.onValidateError(error, 'bibliografia_complementar');
      });
  }

  onValidateError = (error) => {
    this.setState({ submitting: false });
    super.onValidateError(error);
  };

  handleNext = (next) => {
    this.next = next;
    this.formApi.submitForm();
  };

  render() {
    const { fetchingData, bibliografia_complementar } = this.state;

    return (
      <Form
        onValueChange={(values) => {
          this.setState({ save: this.MODIFICADO });
          this.onValueChange(values);
        }}
        getApi={(formApi) => {
          this.formApi = formApi;
        }}
        onSubmit={this.handleSubmit}
      >
        {() => {
          if (fetchingData) {
            return <Loading />;
          }

          return (
            <FormContainer
              next="conteudo"
              title="Referências Bibliográficas"
              onClick={this.onSubmit}
              previous="matrizes-referencia"
            >
              {this.renderSaveStatus()}
              <InputSelect
                multi
                col="col-sm-12 mt-3"
                label="Bibliografia Complementar"
                field="bibliografia_complementar"
                options={bibliografia_complementar}
              />
            </FormContainer>
          );
        }}
      </Form>
    );
  }
}

export default withRouter(ReferenciaBibliograficaComplementar);
